import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/articles',
    name: 'articles',
    component: () => import(/* webpackChunkName: "about" */ '../views/ArticlesView.vue')
  },
  {
    path: '/mobilegames',
    name: 'mobilegames',
    component: () => import(/* webpackChunkName: "about" */ '../views/MobileGamesView.vue')
  },
  {
    path: '/poesy',
    name: 'poesy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PoesyView.vue')
  },
  {
    path: '/cartoon',
    name: 'cartoon',
    component: () => import(/* webpackChunkName: "about" */ '../views/CartoonView.vue')
  },
  {
    path: '/songs',
    name: 'songs',
    component: () => import(/* webpackChunkName: "about" */ '../views/SongsView.vue')
  },
  {
    path: '/3dmodeling',
    name: '3dmodeling',
    component: () => import(/* webpackChunkName: "about" */ '../views/3DModelingView.vue')
  },
  {
    path: '/clips',
    name: 'clips',
    component: () => import(/* webpackChunkName: "about" */ '../views/ClipsView.vue')
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectsView.vue')
  },
  {
    path: '/programing',
    name: 'programing',
    component: () => import(/* webpackChunkName: "about" */ '../views/PortfolioView.vue')
  },
  {
    path: '/volunteer',
    name: 'volunteer',
    component: () => import(/* webpackChunkName: "about" */ '../views/VolunteerView.vue')
  },
  {
    path: '/robotics',
    name: 'robotics',
    component: () => import(/* webpackChunkName: "about" */ '../views/RoboticView.vue')
  },
  {
    path: '/websites',
    name: 'websites',
    component: () => import(/* webpackChunkName: "about" */ '../views/WebSitesView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
